export default __webpack_public_path__ + "static/media/mc_5Suit.55a0baba.png";